var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed-management-container"},[_c('a',{on:{"click":_vm.back}},[_c('IxRes',[_vm._v("GoBackToFarmOverview")])],1),_c('SimpleTable',{attrs:{"data":_vm.allFeeds,"columns":_vm.columns,"localize-headers":""},scopedSlots:_vm._u([{key:"isFavorite",fn:function(ref){
var value = ref.value;
return [_c('span',{staticClass:"fa",class:value ? 'fa-star' : 'fa-star-o'})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }